/**
 * IoT Defense Typed.js Hero Animation
 * Creates the "Internet of Threats/Targets/Things" typing effect
 */
(function() {
    'use strict';

    // Only initialize if the typed-text element exists
    var typedElement = document.getElementById('typed-text');
    if (!typedElement) return;

    // Check if Typed.js is loaded
    if (typeof Typed === 'undefined') {
        console.warn('Typed.js not loaded');
        return;
    }

    new Typed('#typed-text', {
        strings: [
            'Internet of Threats',
            'Internet of Targets',
            'Internet of Things',
            'IoT Defense'
        ],
        typeSpeed: 80,
        backSpeed: 40,
        backDelay: 2000,
        startDelay: 500,
        loop: true,
        showCursor: false, // We use custom CSS cursor
        contentType: 'html'
    });
})();
